import { MeterBarTooltip } from '../../shared/components/meter-bar-tooltip/MeterBarTooltip.js';
import { useMultiMeterBarChartTooltipData } from '../context/MultiMeterBarChartTooltipContext.js';
import { useMultiMeterBarChartTooltipItems } from '../hooks/use-multi-meter-bar-chart-tooltip-items.js';

export const MultiMeterBarChartTooltip = () => {
  const { tooltipConfig } = useMultiMeterBarChartTooltipData();
  const isTooltipEnabled = tooltipConfig.enabled;
  const tooltipItems = useMultiMeterBarChartTooltipItems();

  if (!tooltipItems || !isTooltipEnabled) {
    return null;
  }

  return <MeterBarTooltip items={tooltipItems} />;
};
